/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tr_6_QInputs */

const en_mk_tut_tr_6_q = /** @type {(inputs: Mk_Tut_Tr_6_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This month’s cost is climbing faster than I expected.`)
};

const id_mk_tut_tr_6_q = /** @type {(inputs: Mk_Tut_Tr_6_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya bulan ini naik lebih cepat dari perkiraan.`)
};

/**
* | output |
* | --- |
* | "This month’s cost is climbing faster than I expected." |
*
* @param {Mk_Tut_Tr_6_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tr_6_q = /** @type {((inputs?: Mk_Tut_Tr_6_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tr_6_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tr_6_q(inputs)
	return en_mk_tut_tr_6_q(inputs)
});